const CHECKOUT_MUTATIONS = new Set<string>([
    'AddToCart',
    'AddToCartWithCustomizableAssets',
    'AdjustItemQuantity',
    'RemoveItemFromCart',
    'ApplyCoupon',
    'removeCouponCode',
    'SetOrderUtmInfo',
    'SetCustomerForOrder',
    'ValidateAddress',
    'SetShippingAddress',
    'SetShippingMethod',
    'SetShippingMethodWithRate',
    'TransitionToArrangingPayment',
    'TransitionToAddingItems',
    'AddPayment',
    'CreateStripePaymentIntent',
  ]);

  export function requiresChannelToken(operationName?: string): boolean {
    if (!operationName) return false;
    return CHECKOUT_MUTATIONS.has(operationName);
  }